<soft-page>
  @if ({ canEdit: canEdit$ | async }; as vm) {
    <!--gesperrt ?-->
    @if (!vm?.canEdit) {
      <div class="sticky top-[-0.5rem] left-[-1rem] right-[1rem]" style="z-index: 99999">
        <div
          class="py-2 bg-background"
          style="background-color: var(--shellContentBackground)"
        >
          @if (!vm?.canEdit) {
            <div
              class="px-4 py-4 text-error border border-danger border-solid"
              style="background-color: var(--colorDanger200)"
            >
              Auftrag ist von {{ lockedByUser$ | async }} gesperrt!
            </div>
          }
        </div>
      </div>
    }
    <!---->

    @if (item$ | async; as item) {
      <div class="flex flex-col gap-3">
        <!-- <section>
        <span class="font-semibold text-2xl">
          {{ '#DELIVERY_NOTE.DETAILS.CONSTRUCTION_SITE' | translate }}
          <br />
          {{ item.adresseBean?.kurzbez }}
        </span>
        <br />
        <span class="text-light text-sm">
          {{ item.type?.bezeichnung }} {{ item.belegnummer }}
        </span>
      </section> -->

        @if (item?.lieferadresseBean) {
          <soft-delivery-note-address-card
            [address]="item.lieferadresseBean"
            [lieferdatum]="item.lieferdatum"
            [paletten]="item.paletten"
            [palettenModus]="item.palettenModus"
            [headerText]="'Baustelle'"
            (fotoClicked)="onFotoClicked(item)"
          />
        }
        @if (item?.adresseBean) {
          <soft-delivery-note-address-card
            [address]="item.adresseBean"
            [lieferdatum]="item.lieferdatum"
            [paletten]="item.paletten"
            [palettenModus]="item.palettenModus"
            [headerText]="'Kunde'"
            (fotoClicked)="onFotoClicked(item)"
          />
        }

        @if (item.palettenModus !== PalettenModus.Keine) {
          <soft-ds-card [chevron]="true" (click)="navigate(item.id)">
            <soft-ds-card-body>
              <div class="flex flex-cols gap-3">
                @if ((scanningDone$ | async) === false) {
                  <div
                    class="flex items-center justify-center w-10 h-10 rounded-lg bg-orange-300"
                  >
                    <soft-icon
                      name="fa-regular fa-barcode-scan text-orange-500 text-lg"
                    />
                  </div>
                } @else {
                  <div
                    class="flex items-center justify-center w-10 h-10 rounded-lg bg-success-400"
                  >
                    <soft-icon name="fa-regular fa-check text-success-600 text-lg" />
                  </div>
                }
                <div class="flex flex-col flex-1">
                  <span
                    class="font-semibold"
                    [class]="(scanningDone$ | async) ? 'text-success-600' : ''"
                  >
                    {{
                      '#DELIVERY_NOTE.DETAILS.PALETTEN_MODUS.' + $safeNavigationMigration(item?.palettenModus)
                        | translate
                    }}
                    {{ (scanningDone$ | async) ? 'abgeschlossen' : '' }}
                  </span>
                  <span class="text-sm text-light">
                    {{
                      (scanningDone$ | async) === true
                        ? item.paletten.length + ' / ' + item.paletten.length
                        : (numOfNotErledigtPaletten$ | async) +
                          ' Paletten — noch nicht gescannt'
                    }}
                  </span>
                </div>
              </div>
            </soft-ds-card-body>
          </soft-ds-card>
        }

        <!--lieferhinweis-->
        @if (item?.lieferhinweis && (item?.lieferhinweis?.length ?? 0) > 0) {
          <div class="font-semibold text-sm uppercase">
            {{ '#DELIVERY_NOTE.DETAILS.DELIVERY_INFO_TITLE' | translate }}
          </div>
          <soft-ds-card>
            <soft-ds-card-body>
              <div class="flex flex-col gap-0.5">
                @for (text of deliveryInfos$ | async; track text; let first = $first) {
                  <p class="text-orange-700" [class.mt-1]="!first">{{ text }}</p>
                }
              </div>
            </soft-ds-card-body>
          </soft-ds-card>
        }
        <!---->

        <!--vermerk-->
        @if (item?.vermerk) {
          <ng-container>
            <div class="flex flex-row justify-between flex-nowrap">
              <div class="soft-overline text-base mb-2">
                {{ '#DELIVERY_NOTE.DETAILS.VERMERK_TITLE' | translate }}
              </div>
              @if (vermerkChanged$ | async) {
                <span class="text-red">*</span>
              }
            </div>
            <div
              class="mb-5 flex border border-solid border-gray-300 rounded p-4 flex border-box"
            >
              <span>{{ item?.vermerk }}</span>
            </div>
          </ng-container>
        }
        <!---->

        @if (item?.bewelfs) {
          <div class="font-semibold text-sm uppercase">
            {{ item?.type?.bezeichnung }}
          </div>
          <div class="flex flex-col gap-2 w-full">
            @for (material of item.bewelfs; track material) {
              <soft-delivery-note-material-card
                [idKopfLf]="item.id"
                [deliveryMaterial]="material"
              />
            }
          </div>
        }

        <!--returnNoteChanges-->
        @if (
          (returnNoteChanges$ | async) &&
            (returnNoteWithNonZeroQuantityGroupedBewes$ | async);
          as retourNote
        ) {
          <div class="soft-overline text-base mb-2">
            {{ '#DELIVERY_NOTE.HEADERS.RETURN' | translate }}
          </div>
          @if (retourNote) {
            <div class="mb-5 flex flex-col w-full mt-1">
              @for (bewe of retourNote?.bewes; track bewe) {
                @if ((bewe?.bewes?.length ?? 0) > 0) {
                  <section>
                    <header
                      class="mt-2 mb-2 text-xs font-semibold uppercase tracking-wide flex items-center opacity-70"
                    >
                      {{ bewe.text | translate }}
                      <span
                        class="border-b border-solid border-gray-300 ml-2 w-full flex-1 h-[1px] transform translate-y-[0.5px]"
                      >
                        &nbsp;
                      </span>
                    </header>
                    @switch (bewe.type) {
                      @case ('itemScan') {
                        @for (bewe of bewe.bewes; track bewe) {
                          <lib-delivery-note-return-card
                            [bewe]="bewe"
                            [deliveryNoteId]="$any(bewe)?.idbewelf ?? retourNote.id"
                            [bewelf]="undefined"
                          />
                        }
                      }
                      @case ('search') {
                        @for (bewe of bewe.bewes; track bewe) {
                          <lib-delivery-note-return-card
                            [bewe]="bewe"
                            [deliveryNoteId]="$safeNavigationMigration(retourNote?.id)"
                            [bewelf]="$safeNavigationMigration($any(bewe)?.bewelf)"
                          />
                        }
                      }
                      @default {
                        @for (bewe of bewe.bewes; track bewe) {
                          <lib-delivery-note-return-card
                            [bewe]="bewe"
                            [deliveryNoteId]="$any(bewe)?.idbewelf ?? retourNote?.id"
                            [bewelf]="
                              item.bewelfs
                                | single: filterSingleBewelf : $safeNavigationMigration($any(bewe)?.idbewelf)
                            "
                          />
                        }
                      }
                    }
                  </section>
                }
              }
            </div>
          }
        }
        <!---->

        <!--FOTOS-->
        @if (vm?.canEdit) {
          <div class="font-semibold text-sm uppercase">
            {{ '#DELIVERY_NOTE.HEADERS.PHOTOS' | translate }}
          </div>
          @if (item?.archiveKey) {
            <div class="mb-2">
              <soft-archive-list [archiveKey]="$safeNavigationMigration(item?.archiveKey)" />
            </div>
          }
          <soft-file-input
            [value]="item.files ?? []"
            [selectionMode]="'multi'"
            [sources]="['camera']"
            (valueChange)="patchNote(+item.id, { files: $event })"
          />
        }
        <!---->

        <!--signature-->
        @if (
          item?.palettenModus === PalettenModus.Keine ||
          item?.palettenModus === PalettenModus.Erledigt
        ) {
          <div class="mb-4 pb-3">
            <div class="font-semibold text-sm uppercase">
              {{ '#DELIVERY_NOTE.DETAILS.SIGNATURE.OVERLINE' | translate }}
            </div>
            <div
              class="signature-input pos-rel mt-2"
              (click)="vm?.canEdit && openSignaturePad(item)"
              [class.disabled]="!vm?.canEdit"
            >
              @if (item?.signatureBlob) {
                <div
                  class="signature-image"
                  [ngStyle]="{
                    backgroundImage:
                      'url(' +
                      ((item.signatureBlob | localImage | async) || 'none') +
                      ')',
                  }"
                ></div>
              }
              <small class="text-xs color-light">
                {{ '#DELIVERY_NOTE.DETAILS.SIGNATURE.TAP_TO_ADD_INFO' | translate }}
              </small>
            </div>
          </div>
        }
        <!---->

        <section>
          @if (
            item?.palettenModus === PalettenModus.Beladen ||
            item?.palettenModus === PalettenModus.Entladen
          ) {
            <soft-ds-card
              [style.--ds-card-surface]="'var(--ds-surface-status-warning-muted)'"
            >
              <soft-ds-card-body>
                <div class="flex items-center justify-center">
                  <soft-ds-icon name="fa-regular fa-circle-info" color="warning" />
                  <span class="text-warning-700">
                    {{
                      '#DELIVERY_NOTE.DETAILS.PALETTEN_MODUS.' + $safeNavigationMigration(item?.palettenModus)
                        | translate
                    }}
                    erforderlich vor Abschluss
                  </span>
                </div>
              </soft-ds-card-body>
            </soft-ds-card>
          }
          <soft-ds-button
            variant="primary"
            size="lg"
            class="mt-1 w-full"
            style="--ds-button-height-lg: 3.5rem"
            [disabled]="!vm?.canEdit || saving || !item?.signatureBlob"
            (click)="complete(item.id, item)"
          >
            @if (saving) {
              <i class="fa-regular fa-spinner fa-spin"></i>
            }
            Abschließen
          </soft-ds-button>
        </section>
      </div>
    }
  }
</soft-page>
